export const SEND_SMS_OTP_REQUEST = "SEND_SMS_OTP_REQUEST";
export const SEND_SMS_OTP_SUCCESS = "SEND_SMS_OTP_SUCCESS";
export const SEND_SMS_OTP_FAILURE = "SEND_SMS_OTP_FAILURE";

export const SMS_OTP_SIGNIN_REQUEST = "SMS_OTP_SIGNIN_REQUEST";
export const SMS_OTP_SIGNIN_SUCCESS = "SMS_OTP_SIGNIN_SUCCESS";
export const SMS_OTP_SIGNIN_FAILURE = "SMS_OTP_SIGNIN_FAILURE";
